<template>
  <svg
    class="iconGithub"
    :width="width"
    :height="height"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.9976 8.75C20.5024 8.75 8.75 20.5024 8.75 35.0008C8.75 46.5985 16.2707 56.4365 26.7017 59.9093C28.0151 60.1494 28.4937 59.3388 28.4937 58.6426C28.4937 58.0206 28.4711 56.3689 28.4582 54.1789C21.1567 55.7646 19.6161 50.6594 19.6161 50.6594C18.422 47.6283 16.701 46.8209 16.701 46.8209C14.3176 45.1917 16.8815 45.2239 16.8815 45.2239C19.5162 45.4109 20.9021 47.9296 20.9021 47.9296C23.2435 51.9405 27.0466 50.7819 28.542 50.1115C28.7805 48.4147 29.4574 47.2576 30.2083 46.6018C24.3796 45.9394 18.2512 43.6866 18.2512 33.6278C18.2512 30.7626 19.2745 28.4196 20.9536 26.5841C20.6829 25.9202 19.7821 23.2516 21.2099 19.6371C21.2099 19.6371 23.4144 18.9312 28.4292 22.3282C30.5225 21.7465 32.7689 21.4548 35.0008 21.4451C37.2295 21.4548 39.4758 21.7465 41.5724 22.3282C46.584 18.9312 48.7837 19.6371 48.7837 19.6371C50.2163 23.2516 49.3155 25.9202 49.0447 26.5841C50.7271 28.4196 51.7439 30.7626 51.7439 33.6278C51.7439 43.7124 45.6059 45.9314 39.7579 46.5808C40.7006 47.3914 41.5401 48.9932 41.5401 51.4426C41.5401 54.9508 41.5079 57.7821 41.5079 58.6426C41.5079 59.3452 41.9801 60.1623 43.3128 59.906C53.7357 56.4269 61.25 46.5953 61.25 35.0008C61.25 20.5024 49.496 8.75 34.9976 8.75Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "github",
    },
    width: {
      type: [Number, String],
      default: 40,
    },
    height: {
      type: [Number, String],
      default: 40,
    },
    iconColor: {
      type: String,
      default: "#ffffff",
    },
  },
};
</script>
